import React from 'react'

import { FadeInOut } from '@pb/components'

import InboxContent from '../InboxContent'
import styles from './InboxFlyout.scss'

const InboxFlyout: React.FC<any> = ({ isOpen, isLargeScreen }) => {
  return isLargeScreen ? (
    <FadeInOut isVisible={isOpen} className={styles.container}>
      <InboxContent />
    </FadeInOut>
  ) : null
}

export default InboxFlyout
